/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateUpdateSupportingExaminationDto } from './CreateUpdateSupportingExaminationDto';
import {
    CreateUpdateSupportingExaminationDtoFromJSON,
    CreateUpdateSupportingExaminationDtoFromJSONTyped,
    CreateUpdateSupportingExaminationDtoToJSON,
} from './CreateUpdateSupportingExaminationDto';

/**
 * 
 * @export
 * @interface CreateUpdateExamWithTestsDto
 */
export interface CreateUpdateExamWithTestsDto {
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateExamWithTestsDto
     */
    number?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    examinedId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    psychologistUID?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateExamWithTestsDto
     */
    registrationDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateExamWithTestsDto
     */
    articlePsychologistsIds?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateExamWithTestsDto
     */
    articleDoctorsIds?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    drivingLicense?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateExamWithTestsDto
     */
    occupationalMedicineCategory?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    occupationalMedicineText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    type?: CreateUpdateExamWithTestsDtoTypeEnum | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateExamWithTestsDto
     */
    referralDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    employerName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    employerAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    employmentPosition?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamWithTestsDto
     */
    employmentCandidate?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    employeePeriod?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    sportsClubName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    sportsClubAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    sportsDiscipline?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateExamWithTestsDto
     */
    lossOfAbilityDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    kindOfScience?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateExamWithTestsDto
     */
    endScience?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    schoolName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    schoolAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    fieldOfStudy?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamWithTestsDto
     */
    schoolCandidate?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    schoolPeriod?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    takenCareOf?: CreateUpdateExamWithTestsDtoTakenCareOfEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamWithTestsDto
     */
    referralFromEmployer?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamWithTestsDto
     */
    areHarmfulFactors?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamWithTestsDto
     */
    areResultsHarmfulFactors?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateExamWithTestsDto
     */
    harmfulFactorsIds?: Array<string> | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateExamWithTestsDto
     */
    endDate?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamWithTestsDto
     */
    completed?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamWithTestsDto
     */
    neurologist?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamWithTestsDto
     */
    ophthalmologist?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamWithTestsDto
     */
    laryngologist?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamWithTestsDto
     */
    psychologistConsultation?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamWithTestsDto
     */
    psychiatrist?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamWithTestsDto
     */
    ophthalmologistEnded?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamWithTestsDto
     */
    laryngologistEnded?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamWithTestsDto
     */
    neurologistEnded?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamWithTestsDto
     */
    psychiatristEnded?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    batteryId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    healthcare?: CreateUpdateExamWithTestsDtoHealthcareEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    examPackageId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamWithTestsDto
     */
    external?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    whoExamined?: CreateUpdateExamWithTestsDtoWhoExaminedEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamWithTestsDto
     */
    alarm?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamWithTestsDto
     */
    online?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamWithTestsDto
     */
    remote?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamWithTestsDto
     */
    inFacility?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    paid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    paymentType?: CreateUpdateExamWithTestsDtoPaymentTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    sellDocumentType?: CreateUpdateExamWithTestsDtoSellDocumentTypeEnum | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateExamWithTestsDto
     */
    paymentDate?: Date | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateExamWithTestsDto
     */
    testsId?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateExamWithTestsDto
     */
    countOfExams?: number | null;
    /**
     * 
     * @type {Array<CreateUpdateSupportingExaminationDto>}
     * @memberof CreateUpdateExamWithTestsDto
     */
    supportingExamination?: Array<CreateUpdateSupportingExaminationDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    companyId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    officialName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    nip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamWithTestsDto
     */
    sendCompanyEmail?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    healthcareFacilityId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    ownerId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateExamWithTestsDto
     */
    ts?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamWithTestsDto
     */
    visitRegistrationId?: string | null;
}


/**
 * @export
 */
export const CreateUpdateExamWithTestsDtoTypeEnum = {
    Initial: 'Initial',
    Periodic: 'Periodic',
    Control: 'Control',
    PeriodicControl: 'PeriodicControl'
} as const;
export type CreateUpdateExamWithTestsDtoTypeEnum = typeof CreateUpdateExamWithTestsDtoTypeEnum[keyof typeof CreateUpdateExamWithTestsDtoTypeEnum];

/**
 * @export
 */
export const CreateUpdateExamWithTestsDtoTakenCareOfEnum = {
    Employee: 'Employee',
    Outwork: 'Outwork',
    Student: 'Student',
    OwnRequest: 'OwnRequest'
} as const;
export type CreateUpdateExamWithTestsDtoTakenCareOfEnum = typeof CreateUpdateExamWithTestsDtoTakenCareOfEnum[keyof typeof CreateUpdateExamWithTestsDtoTakenCareOfEnum];

/**
 * @export
 */
export const CreateUpdateExamWithTestsDtoHealthcareEnum = {
    Doctor: 'Doctor',
    Dentist: 'Dentist',
    Midwife: 'Midwife',
    Nurse: 'Nurse'
} as const;
export type CreateUpdateExamWithTestsDtoHealthcareEnum = typeof CreateUpdateExamWithTestsDtoHealthcareEnum[keyof typeof CreateUpdateExamWithTestsDtoHealthcareEnum];

/**
 * @export
 */
export const CreateUpdateExamWithTestsDtoWhoExaminedEnum = {
    Student: 'Student',
    Employee: 'Employee',
    Sanitary: 'Sanitary',
    EmployeeAndSanitary: 'EmployeeAndSanitary',
    StudentAndSanitary: 'StudentAndSanitary',
    SanitaryStudent: 'SanitaryStudent'
} as const;
export type CreateUpdateExamWithTestsDtoWhoExaminedEnum = typeof CreateUpdateExamWithTestsDtoWhoExaminedEnum[keyof typeof CreateUpdateExamWithTestsDtoWhoExaminedEnum];

/**
 * @export
 */
export const CreateUpdateExamWithTestsDtoPaymentTypeEnum = {
    Gotwka: 'Gotówka',
    Karta: 'Karta',
    Przelew: 'Przelew',
    Patno_mobilna: 'Płatność mobilna'
} as const;
export type CreateUpdateExamWithTestsDtoPaymentTypeEnum = typeof CreateUpdateExamWithTestsDtoPaymentTypeEnum[keyof typeof CreateUpdateExamWithTestsDtoPaymentTypeEnum];

/**
 * @export
 */
export const CreateUpdateExamWithTestsDtoSellDocumentTypeEnum = {
    Paragon: 'Paragon',
    Faktura: 'Faktura'
} as const;
export type CreateUpdateExamWithTestsDtoSellDocumentTypeEnum = typeof CreateUpdateExamWithTestsDtoSellDocumentTypeEnum[keyof typeof CreateUpdateExamWithTestsDtoSellDocumentTypeEnum];


/**
 * Check if a given object implements the CreateUpdateExamWithTestsDto interface.
 */
export function instanceOfCreateUpdateExamWithTestsDto(value: object): value is CreateUpdateExamWithTestsDto {
    return true;
}

export function CreateUpdateExamWithTestsDtoFromJSON(json: any): CreateUpdateExamWithTestsDto {
    return CreateUpdateExamWithTestsDtoFromJSONTyped(json, false);
}

export function CreateUpdateExamWithTestsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateExamWithTestsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'] == null ? undefined : json['number'],
        'examinedId': json['examinedId'] == null ? undefined : json['examinedId'],
        'psychologistUID': json['psychologistUID'] == null ? undefined : json['psychologistUID'],
        'registrationDate': json['registrationDate'] == null ? undefined : (new Date(json['registrationDate'])),
        'description': json['description'] == null ? undefined : json['description'],
        'articlePsychologistsIds': json['articlePsychologistsIds'] == null ? undefined : json['articlePsychologistsIds'],
        'articleDoctorsIds': json['articleDoctorsIds'] == null ? undefined : json['articleDoctorsIds'],
        'drivingLicense': json['drivingLicense'] == null ? undefined : json['drivingLicense'],
        'occupationalMedicineCategory': json['occupationalMedicineCategory'] == null ? undefined : json['occupationalMedicineCategory'],
        'occupationalMedicineText': json['occupationalMedicineText'] == null ? undefined : json['occupationalMedicineText'],
        'type': json['type'] == null ? undefined : json['type'],
        'referralDate': json['referralDate'] == null ? undefined : (new Date(json['referralDate'])),
        'employerName': json['employerName'] == null ? undefined : json['employerName'],
        'employerAddress': json['employerAddress'] == null ? undefined : json['employerAddress'],
        'employmentPosition': json['employmentPosition'] == null ? undefined : json['employmentPosition'],
        'employmentCandidate': json['employmentCandidate'] == null ? undefined : json['employmentCandidate'],
        'employeePeriod': json['employeePeriod'] == null ? undefined : json['employeePeriod'],
        'sportsClubName': json['sportsClubName'] == null ? undefined : json['sportsClubName'],
        'sportsClubAddress': json['sportsClubAddress'] == null ? undefined : json['sportsClubAddress'],
        'sportsDiscipline': json['sportsDiscipline'] == null ? undefined : json['sportsDiscipline'],
        'lossOfAbilityDate': json['lossOfAbilityDate'] == null ? undefined : (new Date(json['lossOfAbilityDate'])),
        'kindOfScience': json['kindOfScience'] == null ? undefined : json['kindOfScience'],
        'endScience': json['endScience'] == null ? undefined : (new Date(json['endScience'])),
        'schoolName': json['schoolName'] == null ? undefined : json['schoolName'],
        'schoolAddress': json['schoolAddress'] == null ? undefined : json['schoolAddress'],
        'fieldOfStudy': json['fieldOfStudy'] == null ? undefined : json['fieldOfStudy'],
        'schoolCandidate': json['schoolCandidate'] == null ? undefined : json['schoolCandidate'],
        'schoolPeriod': json['schoolPeriod'] == null ? undefined : json['schoolPeriod'],
        'takenCareOf': json['takenCareOf'] == null ? undefined : json['takenCareOf'],
        'referralFromEmployer': json['referralFromEmployer'] == null ? undefined : json['referralFromEmployer'],
        'areHarmfulFactors': json['areHarmfulFactors'] == null ? undefined : json['areHarmfulFactors'],
        'areResultsHarmfulFactors': json['areResultsHarmfulFactors'] == null ? undefined : json['areResultsHarmfulFactors'],
        'harmfulFactorsIds': json['harmfulFactorsIds'] == null ? undefined : json['harmfulFactorsIds'],
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'completed': json['completed'] == null ? undefined : json['completed'],
        'neurologist': json['neurologist'] == null ? undefined : json['neurologist'],
        'ophthalmologist': json['ophthalmologist'] == null ? undefined : json['ophthalmologist'],
        'laryngologist': json['laryngologist'] == null ? undefined : json['laryngologist'],
        'psychologistConsultation': json['psychologistConsultation'] == null ? undefined : json['psychologistConsultation'],
        'psychiatrist': json['psychiatrist'] == null ? undefined : json['psychiatrist'],
        'ophthalmologistEnded': json['ophthalmologistEnded'] == null ? undefined : json['ophthalmologistEnded'],
        'laryngologistEnded': json['laryngologistEnded'] == null ? undefined : json['laryngologistEnded'],
        'neurologistEnded': json['neurologistEnded'] == null ? undefined : json['neurologistEnded'],
        'psychiatristEnded': json['psychiatristEnded'] == null ? undefined : json['psychiatristEnded'],
        'batteryId': json['batteryId'] == null ? undefined : json['batteryId'],
        'healthcare': json['healthcare'] == null ? undefined : json['healthcare'],
        'examPackageId': json['examPackageId'] == null ? undefined : json['examPackageId'],
        'external': json['external'] == null ? undefined : json['external'],
        'whoExamined': json['whoExamined'] == null ? undefined : json['whoExamined'],
        'alarm': json['alarm'] == null ? undefined : json['alarm'],
        'online': json['online'] == null ? undefined : json['online'],
        'remote': json['remote'] == null ? undefined : json['remote'],
        'inFacility': json['inFacility'] == null ? undefined : json['inFacility'],
        'paid': json['paid'] == null ? undefined : json['paid'],
        'paymentType': json['paymentType'] == null ? undefined : json['paymentType'],
        'sellDocumentType': json['sellDocumentType'] == null ? undefined : json['sellDocumentType'],
        'paymentDate': json['paymentDate'] == null ? undefined : (new Date(json['paymentDate'])),
        'testsId': json['testsId'] == null ? undefined : json['testsId'],
        'countOfExams': json['countOfExams'] == null ? undefined : json['countOfExams'],
        'supportingExamination': json['supportingExamination'] == null ? undefined : ((json['supportingExamination'] as Array<any>).map(CreateUpdateSupportingExaminationDtoFromJSON)),
        'companyId': json['companyId'] == null ? undefined : json['companyId'],
        'name': json['name'] == null ? undefined : json['name'],
        'officialName': json['officialName'] == null ? undefined : json['officialName'],
        'address': json['address'] == null ? undefined : json['address'],
        'nip': json['nip'] == null ? undefined : json['nip'],
        'email': json['email'] == null ? undefined : json['email'],
        'sendCompanyEmail': json['sendCompanyEmail'] == null ? undefined : json['sendCompanyEmail'],
        'healthcareFacilityId': json['healthcareFacilityId'] == null ? undefined : json['healthcareFacilityId'],
        'ownerId': json['ownerId'] == null ? undefined : json['ownerId'],
        'ts': json['ts'] == null ? undefined : (new Date(json['ts'])),
        'visitRegistrationId': json['visitRegistrationId'] == null ? undefined : json['visitRegistrationId'],
    };
}

export function CreateUpdateExamWithTestsDtoToJSON(value?: CreateUpdateExamWithTestsDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'number': value['number'],
        'examinedId': value['examinedId'],
        'psychologistUID': value['psychologistUID'],
        'registrationDate': value['registrationDate'] == null ? undefined : ((value['registrationDate'] as any).toISOString()),
        'description': value['description'],
        'articlePsychologistsIds': value['articlePsychologistsIds'],
        'articleDoctorsIds': value['articleDoctorsIds'],
        'drivingLicense': value['drivingLicense'],
        'occupationalMedicineCategory': value['occupationalMedicineCategory'],
        'occupationalMedicineText': value['occupationalMedicineText'],
        'type': value['type'],
        'referralDate': value['referralDate'] == null ? undefined : ((value['referralDate'] as any).toISOString()),
        'employerName': value['employerName'],
        'employerAddress': value['employerAddress'],
        'employmentPosition': value['employmentPosition'],
        'employmentCandidate': value['employmentCandidate'],
        'employeePeriod': value['employeePeriod'],
        'sportsClubName': value['sportsClubName'],
        'sportsClubAddress': value['sportsClubAddress'],
        'sportsDiscipline': value['sportsDiscipline'],
        'lossOfAbilityDate': value['lossOfAbilityDate'] == null ? undefined : ((value['lossOfAbilityDate'] as any).toISOString()),
        'kindOfScience': value['kindOfScience'],
        'endScience': value['endScience'] == null ? undefined : ((value['endScience'] as any).toISOString()),
        'schoolName': value['schoolName'],
        'schoolAddress': value['schoolAddress'],
        'fieldOfStudy': value['fieldOfStudy'],
        'schoolCandidate': value['schoolCandidate'],
        'schoolPeriod': value['schoolPeriod'],
        'takenCareOf': value['takenCareOf'],
        'referralFromEmployer': value['referralFromEmployer'],
        'areHarmfulFactors': value['areHarmfulFactors'],
        'areResultsHarmfulFactors': value['areResultsHarmfulFactors'],
        'harmfulFactorsIds': value['harmfulFactorsIds'],
        'endDate': value['endDate'] == null ? undefined : ((value['endDate'] as any).toISOString()),
        'completed': value['completed'],
        'neurologist': value['neurologist'],
        'ophthalmologist': value['ophthalmologist'],
        'laryngologist': value['laryngologist'],
        'psychologistConsultation': value['psychologistConsultation'],
        'psychiatrist': value['psychiatrist'],
        'ophthalmologistEnded': value['ophthalmologistEnded'],
        'laryngologistEnded': value['laryngologistEnded'],
        'neurologistEnded': value['neurologistEnded'],
        'psychiatristEnded': value['psychiatristEnded'],
        'batteryId': value['batteryId'],
        'healthcare': value['healthcare'],
        'examPackageId': value['examPackageId'],
        'external': value['external'],
        'whoExamined': value['whoExamined'],
        'alarm': value['alarm'],
        'online': value['online'],
        'remote': value['remote'],
        'inFacility': value['inFacility'],
        'paid': value['paid'],
        'paymentType': value['paymentType'],
        'sellDocumentType': value['sellDocumentType'],
        'paymentDate': value['paymentDate'] == null ? undefined : ((value['paymentDate'] as any).toISOString()),
        'testsId': value['testsId'],
        'countOfExams': value['countOfExams'],
        'supportingExamination': value['supportingExamination'] == null ? undefined : ((value['supportingExamination'] as Array<any>).map(CreateUpdateSupportingExaminationDtoToJSON)),
        'companyId': value['companyId'],
        'name': value['name'],
        'officialName': value['officialName'],
        'address': value['address'],
        'nip': value['nip'],
        'email': value['email'],
        'sendCompanyEmail': value['sendCompanyEmail'],
        'healthcareFacilityId': value['healthcareFacilityId'],
        'ownerId': value['ownerId'],
        'ts': value['ts'] == null ? undefined : ((value['ts'] as any).toISOString()),
        'visitRegistrationId': value['visitRegistrationId'],
    };
}

